<template>
    <div class="containerGradient">
        <div class="BindBox">
            <el-table :data="ServiceEmployeeData" border :header-cell-style="CellStyle"
                :header-cell-class-name="CellStyle">
                <el-table-column prop="calling_number" :label="$t('主叫号码')" width="130">
                </el-table-column>
                <el-table-column prop="called_number" :label="$t('被叫号码')" width="130">
                </el-table-column>
                <el-table-column prop="start_time" :label="$t('呼叫时间')" width="170">
                </el-table-column>
                <el-table-column prop="contact_type_text" :label="$t('通话状态')" width="80">
                </el-table-column>
                <el-table-column prop="contact_disposition_text" :label="$t('接听状态')" width="80">
                </el-table-column>
                <el-table-column :label="$t('通话时长')" width="80">
                    <template slot-scope="scope">
                        <span>{{ scope.row.call_duration }}秒</span>
                    </template>
                </el-table-column>
                <el-table-column prop="employee_name" :label="$t('坐席人员')" width="110">
                </el-table-column>
                <el-table-column prop="customer_name" :label="$t('客户类型')" width="120">
                </el-table-column>
                <el-table-column :label="$t('回访状态')" width="80">
                    <template slot-scope="scope">
                        {{ scope.row.completion_status == 1 ? '已完成' : '等待回访' }}
                    </template>
                </el-table-column>
                <!-- <el-table-column :label="$t('通话录音')" width="80">
                    <template slot-scope="scope">
                        <div class="cao">
                            <div class="btnT" v-if="scope.row.recording_url"
                                @click="playRecord(scope.row.recording_url)">{{
                                    $t('播放') }}</div>
                            <div class="btnT" v-else>{{ $t('无') }}</div>
                        </div>
                    </template>
                </el-table-column> -->
                <el-table-column prop="remark" :label="$t('备注')">
                </el-table-column>

            </el-table>
        </div>

        <!-- 分页 -->
        <div class="FenYe">
            <el-pagination @size-change="PPhandleSizeChange" @current-change="PPCurrentChange" background
                :page-size="PPlimit" layout="total,prev, pager, next" :total="pptotal">
            </el-pagination>
        </div>

        <div class="dialogBox">
            <el-dialog :title="$t('播放录音')" :visible.sync="playMp3" width="350px" center @close="handleDialogClose1"
                @opened="handleAudioPlay">
                <div class="AddDialog">
                    <div class="player dja">
                        <audio ref="audioPlayer" muted controls autoplay @loadedmetadata="handleMetadataLoaded">
                            <source :src="audioUrl" type="audio/mpeg">
                            您的浏览器不支持 audio 元素
                        </audio>
                    </div>

                </div>

                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleDialogClose1">{{ $t('关闭') }}</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import i18n from '../../locales/index'

import { get, post, BASE_URL } from "../../libs/tool";
import {
    getCallRecordByUser,

} from "../../api/api";
export default {
    props: {
        user_id: {
            type: String,
            required: true
        },

    },
    data() {
        return {

            ServiceEmployeeData: [],
            PPlimit: 10,
            pppage: 1,
            pptotal: 0,
            playMp3: false,
            audioUrl: '',
            trueDuration: '',
            // 'cbfb28442fe711efb34100163e02d435'


        };
    },
    computed: {

    },
    mounted() {
        this.config_list()
    },
    methods: {

        config_list() {
            let data = {
                // user_id: 'cbfb28442fe711efb34100163e02d435',
                user_id: this.user_id,
                limit: this.PPlimit,
                page: this.pppage,
            };
            get(getCallRecordByUser, data, (res) => {
                if (res.success) {
                    this.ServiceEmployeeData = res.data;
                    this.pptotal = res.total;
                } else {
                    // this.$message(res.message);
                }
            });
        },
        PPhandleSizeChange(e) {
            this.PPlimit = e;
            this.config_list();
        },
        // 页码
        PPCurrentChange(e) {
            this.pppage = e;
            this.config_list();
        },
        handleMetadataLoaded() {
            this.trueDuration = this.$refs.audioPlayer.duration;
        },
        // 点击播放按钮
        playRecord(url) {
            this.audioUrl = url + '?t=' + Date.now();  // 防止缓存
            this.playMp3 = true;
        },

        // 弹窗完全打开后触发播放
        handleAudioPlay() {
            const audio = this.$refs.audioPlayer;
            if (audio.readyState > 0) { // 确保资源已加载
                audio.play().catch(err => {
                    console.log('播放失败:', err);
                });
            }
        },
        handleDialogClose1() {
            this.playMp3 = false;
            this.audioUrl = '';
            if (this.$refs.audioPlayer) {
                this.$refs.audioPlayer.pause();
                this.$refs.audioPlayer.currentTime = 0;
            }
        },

    }
};
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">

.containerGradient{
    padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/CallTab/callList.vue